// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__Lve+c","marks":"Footer_marks__oeidw"};